import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "@/services/api";

export const getRfqs = createAsyncThunk(
    "rfq/getRfqs",
    async (data, { rejectWithValue }) => {
        try {
            const params = new URLSearchParams({
                type: String(data.activetab ?? '').trim(),
                page: String(data.page ?? 1).trim(),
                perPage: String(data.perPage ?? 10).trim(),
                search: String(data.search ?? '').trim(),
                filter: String(data.filter ?? '').trim(),
                sort_order: String(data.sort_order ?? '').trim(),
                start_date: String(data.start_date ?? '').trim(),
                end_date: String(data.end_date ?? '').trim(),
                quotation_status: String(data.quotation_status ?? "").trim(),
                current_owner: String(data.current_owner ?? "").trim(),
                my_status: String(data.my_status ?? "").trim(),
            });

            const response = await api.get(`admin/rfq-list?${params.toString()}`);

            return {
                rfqData: response.data,
                rfqType: data.filter
            };
        } catch (err) {
            return rejectWithValue(err.response?.data || "Failed to get RFQ");
        }
    }
);

export const getRfqById = createAsyncThunk(
    "rfq/getRfqById",
    async (rfq_id, { rejectWithValue }) => {
        try {
            const response = await api.get(`admin/get-rfq-detail/${rfq_id}`);
            return response.data;
        } catch (err) {
            return rejectWithValue(err.response?.data || "Failed to get RFQ details");
        }
    }
);

export const addRfq = createAsyncThunk(
    "rfq/addRfq",
    async (data, { rejectWithValue }) => {
        try {
            let url = "admin/create-rfq";
            if (data.id) {
                url += `/${data.id}`;
            }
            const response = await api.post(url, data);

            return response;
        } catch (err) {
            return rejectWithValue(err.response?.data || `Failed to create RFQ`);
        }
    }
);

export const getRfqMessages = createAsyncThunk(
    "rfq/getRfqMessages",
    async (rfq_id, { rejectWithValue }) => {
        try {
            const response = await api.get(`admin/rfq-discussions/${rfq_id}`);
            return response.data;
        } catch (err) {
            return rejectWithValue(err.response?.data || "Failed to load discussion messages.");
        }
    }
);

export const getCustomRfqFile = createAsyncThunk(
    "rfq/getCustomRfqFile",
    async (rfq_id, { rejectWithValue }) => {
        try {
            const response = await api.get(`admin/get-custom-file/${rfq_id}`);
            return response.data;
        } catch (err) {
            return rejectWithValue(err.response?.data || "Failed to load custom RFQ file.");
        }
    }
);

export const getRfqSummary = createAsyncThunk(
    "rfq/getRfqSummary",
    async (rfq_id, { rejectWithValue }) => {
        try {
            const response = await api.get(`admin/rfq-summary/${rfq_id}`);
            return response.data;
        } catch (err) {
            return rejectWithValue(err.response?.data || "Failed to load rfq summary.");
        }
    }
);


export const saveRfqDiscussion = createAsyncThunk(
    "rfq/saveRfqDiscussion",
    async (formData, { rejectWithValue }) => {
        try {
            const response = await api.post("admin/rfq-discussions", formData, {
                headers: { "Content-Type": "multipart/form-data" },
            });
            return response;
        } catch (err) {
            return rejectWithValue(
                err.response?.data || { status: "error", message: "Failed to add comment" }
            );
        }
    }
);

export const addCustomRfq = createAsyncThunk(
    "rfq/addCustomRfq",
    async (data, { rejectWithValue }) => {
        try {
            // const formData = new FormData();
            // Object.keys(data).forEach((key) => {
            //     let value = data[key];
            //     if (key === "custom_rfq_file") {
            //         if (value instanceof File) {
            //             formData.append(key, value);
            //         }
            //     } else {
            //         formData.append(key, value);
            //     }
            // });
            const response = await api.post('admin/custom-rfq', data, {
                headers: { "Content-Type": "multipart/form-data" },
            });

            return response;
        } catch (err) {
            return rejectWithValue(err.response?.data || `Failed to create RFQ`);
        }
    }
);

export const assignRfqToSalesManager = createAsyncThunk(
    "rfq/assignRfqToSalesManager",
    async (data, { rejectWithValue }) => {
        try {
            const response = await api.post("admin/assign-rfq", data);

            return response;
        } catch (err) {
            return rejectWithValue(err.response?.data || `Failed to assign RFQ`);
        }
    }
);

export const assignRfqToSalesMember = createAsyncThunk(
    "rfq/assignRfqToSalesMember",
    async (data, { rejectWithValue }) => {
        try {
            const response = await api.post(`admin/assign-rfq-to-member/${data?.rfq_id}`, data);

            return response;
        } catch (err) {
            return rejectWithValue(err.response?.data || `Failed to assign RFQ`);
        }
    }
);

export const deleteRfq = createAsyncThunk(
    "rfq/deleteRfq",
    async (id, { rejectWithValue }) => {
        try {
            const response = await api.del("admin/rfqs/" + id);
            return response;
        } catch (err) {
            return rejectWithValue(err.response?.data || "Failed to delete RFQ");
        }
    }
);

export const removeRfqItems = createAsyncThunk(
    "rfq/removeRfqItems",
    async (data, { rejectWithValue }) => {
        try {
            const response = await api.post("admin/delete-rfq-items", data);
            return response;
        } catch (err) {
            return rejectWithValue(err.response?.data || "Failed to delete RFQ item");
        }
    }
);

export const generateRfqQuotation = createAsyncThunk(
    "rfq/generateRfqQuotation",
    async (data, { rejectWithValue }) => {
        try {
            const response = await api.post("admin/generate-quotation", data);
            return response;
        } catch (err) {
            return rejectWithValue(err.response?.data || "Failed to generate quotation");
        }
    }
);

export const generateMaterialSubbmital = createAsyncThunk(
    "rfq/generateMaterialSubbmital",
    async (data, { rejectWithValue }) => {
        try {
            const response = await api.get("admin/generate-material-file/" + data?.rfq_id);
            return response;
        } catch (err) {
            return rejectWithValue(err.response?.data || "Failed to downlaod");
        }
    }
);

export const deleteCustomRfqFile = createAsyncThunk(
    "rfq/deleteCustomRfqFile",
    async (data, { rejectWithValue }) => {
        try {
            const response = await api.post("admin/delete-custom-file", data);
            return response;
        } catch (err) {
            return rejectWithValue(err.response?.data || "Failed to delete RFQ item");
        }
    }
);

export const installationCharge = createAsyncThunk(
    "rfq/installationCharge",
    async (data, { rejectWithValue }) => {
        try {
            const response = await api.post("admin/update-is-installation", data);
            return response;
        } catch (err) {
            return rejectWithValue(err.response?.data || "Failed to change installation charge");
        }
    }
);

export const VATCharge = createAsyncThunk(
    "rfq/VATCharge",
    async (rfq_id, { rejectWithValue }) => {
        try {
            const response = await api.post(`admin/update-is-vat/${rfq_id}`);
            return response;
        } catch (err) {
            return rejectWithValue(err.response?.data || "Failed to change vat charge");
        }
    }
);

export const updateDeliveryCharge = createAsyncThunk(
    "rfq/updateDeliveryCharge",
    async (data, { rejectWithValue }) => {
        try {
            const response = await api.post(`admin/update-rfq-delivery-charge`, data);
            return response;
        } catch (err) {
            return rejectWithValue(err.response?.data || "Failed to update delivery charge");
        }
    }
);

export const approveRfq = createAsyncThunk(
    "rfq/approveRfq",
    async (data, { rejectWithValue }) => {
        try {
            const response = await api.post("admin/approve-reject/" + data?.rfq_id, { status: data.value, reason: data?.reason || '' });
            return response;
        } catch (err) {
            return rejectWithValue(err.response?.data || "Failed to approve/reject RFQ");
        }
    }
);

export const salesApproveRfq = createAsyncThunk(
    "rfq/salesApproveRfq",
    async (data, { rejectWithValue }) => {
        try {
            const response = await api.post("admin/approve-by-sales/" + data?.rfq_id, { status: data.status, reason: data.reason });
            return response;
        } catch (err) {
            return rejectWithValue(err.response?.data || "Failed to approve/reject RFQ");
        }
    }
);

export const procurementApproveRfq = createAsyncThunk(
    "rfq/procurementApproveRfq",
    async (data, { rejectWithValue }) => {
        try {
            const response = await api.post("admin/approve-by-procurement/" + data?.rfq_id, { status: data.status, reason: data.reason });
            return response;
        } catch (err) {
            return rejectWithValue(err.response?.data || "Failed to approve/reject RFQ");
        }
    }
);



export const bulkActionRfq = createAsyncThunk(
    "rfq/bulkActionRfq",
    async (data, { rejectWithValue }) => {
        try {
            const response = await api.post("admin/rfq-bulk-actions", data);
            return response;
        } catch (err) {
            return rejectWithValue(err.response?.data || "Failed to perform this action");
        }
    }
);

export const fetchRFQProduct = createAsyncThunk(
    "rfq/fetchRFQProduct",
    async (data, { rejectWithValue }) => {
        try {
            const response = await api.get(`admin/get-products/${data?.rfq_id}?search=${data?.search || ''}&sort_order=${data?.sort_order || ''}`);
            return response.data;
        } catch (err) {
            return rejectWithValue(err.response?.data || "Failed to load product");
        }
    }
);


export const updateProductQuantity = createAsyncThunk(
    "rfq/updateProductQuantity",
    async (data, { rejectWithValue }) => {
        try {
            const response = await api.post(`admin/rfqs/items/update-quantity`, { item_id: data.item_id, quantity: data.quantity });
            return response.data;
        } catch (err) {
            return rejectWithValue(err.response?.data || "Failed to update product quantity");
        }
    }
);

export const fetchCustomer = createAsyncThunk(
    "rfq/fetchCustomer",
    async (_, { rejectWithValue }) => {
        try {
            const response = await api.get(`admin/get-customer-list`);
            const data = response.data.map(row => ({ value: row.id, label: row.full_name }));
            return data;
        } catch (err) {
            return rejectWithValue(err.response?.data || "Failed to load customer");
        }
    }
);

export const fetchSalesManager = createAsyncThunk(
    "rfq/fetchSalesManager",
    async (formdata, { rejectWithValue }) => {
        try {
            const response = await api.get(`admin/get-sales-manager/${formdata?.office_id}?role=${formdata?.type}`);
            const data = response.data.map(row => ({ value: row.id, label: row.first_name }));
            return data;
        } catch (err) {
            return rejectWithValue(err.response?.data || "Failed to load sales manager");
        }
    }
);

export const fetchSalesTeamMember = createAsyncThunk(
    "rfq/fetchSalesTeamMember",
    async (rfq_id, { rejectWithValue }) => {
        try {
            const response = await api.get(`admin/list-sales-member/${rfq_id}`);
            const data = response.data.map(row => ({ value: row.id, label: row.first_name + " (Rfqs : " + row?.rfq_count + ")" }));
            return data;
        } catch (err) {
            return rejectWithValue(err.response?.data || "Failed to load sales member");
        }
    }
);

export const fetchCartItem = createAsyncThunk(
    "rfq/fetchCartItem",
    async (product_ids, { rejectWithValue }) => {
        try {
            const response = await api.post(`admin/get-cart-items`, { product_ids });
            return response;
        } catch (err) {
            return rejectWithValue(err.response?.data || "Failed to get products");
        }
    }
);

export const fetchRFQCustomerInfo = createAsyncThunk(
    "rfq/fetchRFQCustomerInfo",
    async (rfq_id, { rejectWithValue }) => {
        try {
            const response = await api.get(`admin/get-customer-details/${rfq_id}`);
            return response.data;
        } catch (err) {
            return rejectWithValue(err.response?.data || "Failed to load product");
        }
    }
);


export const fetchTimeLine = createAsyncThunk(
    "rfq/fetchTimeLine",
    async (rfq_id, { rejectWithValue }) => {
        try {
            const response = await api.get(`admin/get-rfq-timeline/${rfq_id}`);
            return response.data;
        } catch (err) {
            return rejectWithValue(err.response?.data || "Failed to load product");
        }
    }
);

export const sendMaterialSubmittal = createAsyncThunk(
    "rfq/sendMaterialSubmittal",
    async (formData, { rejectWithValue }) => {
        try {
            const response = await api.post(`/admin/material-submittal-upload/${formData?.rfq_id}`, formData, {
                headers: { "Content-Type": "multipart/form-data" },
            });
            return response;
        } catch (err) {
            return rejectWithValue(err.response.data || "Failed to send material submittal");
        }
    }
);

export const rfqMoveToOrder = createAsyncThunk(
    "rfq/rfqMoveToOrder",
    async (data, { rejectWithValue }) => {
        try {
            let formData = new FormData();
            Object.entries(data).forEach(([key, value]) => {
                if (key === "purchase_order_file" && value instanceof File) {
                    formData.append("purchase_order_file", value);
                } else if (key !== "purchase_order_file") {
                    formData.append(key, value ?? "");
                }
            });
            const response = await api.post(`/admin/store-order`, formData, {
                headers: { "Content-Type": "multipart/form-data" },
            });
            return response;
        } catch (err) {
            return rejectWithValue(err.response.data || "Failed to move RFQ in order");
        }
    }
);

export const sendRfqToAdmin = createAsyncThunk(
    "rfq/sendRfqToAdmin",
    async (data, { rejectWithValue }) => {
        try {
            const response = await api.post(`/admin/rfq/send-to-admin`, data);
            return response;
        } catch (err) {
            return rejectWithValue(err.response.data || "Failed to send RFQ to admin");
        }
    }
);
export const sendRfqToManager = createAsyncThunk(
    "rfq/sendRfqToManager",
    async (data, { rejectWithValue }) => {
        try {
            const response = await api.post(`/admin/rfq/send-to-sales`, data);
            return response;
        } catch (err) {
            return rejectWithValue(err.response.data || "Failed to send RFQ to manager");
        }
    }
);

export const sendRfqToProcurementManager = createAsyncThunk(
    "rfq/sendRfqToProcurementManager",
    async (data, { rejectWithValue }) => {
        try {
            const response = await api.post(`/admin/rfq/send-to-procurement`, data);
            return response;
        } catch (err) {
            return rejectWithValue(err.response.data || "Failed to send RFQ to manager");
        }
    }
);

export const getPriceVrientVendor = createAsyncThunk(
    "rfq/getPriceVrientVendor",
    async (formdata, { rejectWithValue }) => {
        try {
            const response = await api.post(`admin/get-rfq-product/avilable-vendor`, formdata);

            const data = response.data.map(row => ({ value: row.id, label: `${row.name}  (Location : ${row?.address ? row.address : 'N/A'}) - (Price : ${row?.currency_code ? row.currency_code : ''} ${row.price ? row.price : 'N/A'}) `, price: row.price, vendor_type: row.vendor_type }));
            return { index: formdata.index, data: data };
        } catch (err) {
            return rejectWithValue(err.response?.data || "Failed to load vendors");
        }
    }
);
export const addVendorPrice = createAsyncThunk(
    "rfq/addVendorPrice",
    async (data, { rejectWithValue }) => {
        try {
            const formData = new FormData();

            Object.entries(data).forEach(([key, value]) => {
                if (key === "vendors" && Array.isArray(value)) {
                    value.forEach((vendor, index) => {
                        Object.entries(vendor).forEach(([vendorKey, vendorValue]) => {
                            if (vendorKey === "vendor_file") {
                                if (vendorValue instanceof File) {
                                    formData.append(
                                        `vendors[${index}][vendor_file]`,
                                        vendorValue
                                    );
                                } else if (typeof vendorValue === "string") {
                                    formData.append(
                                        `vendors[${index}][old_vendor_file]`,
                                        vendorValue
                                    );
                                }
                            }
                            else if (vendorValue !== undefined && vendorValue !== null) {
                                formData.append(
                                    `vendors[${index}][${vendorKey}]`,
                                    vendorValue
                                );
                            }
                        });
                    });
                }

                else if (value !== undefined && value !== null) {
                    formData.append(key, value);
                }
            });

            const response = await api.post(
                "admin/rfq-product/add-vendor-price",
                formData,
                {
                    headers: { "Content-Type": "multipart/form-data" },
                }
            );

            return response;
        } catch (err) {
            return rejectWithValue(
                err.response?.data || "Failed to add vendor price"
            );
        }
    }
);

export const getVendorPrice = createAsyncThunk(
    "rfq/getVendorPrice",
    async (formdata, { rejectWithValue }) => {
        try {
            const response = await api.get(`admin/rfq-product/get-vendor-price`, formdata);
            return response.data;
        } catch (err) {
            return rejectWithValue(err.response?.data || "Failed to get vendor price");
        }
    }
);

export const saveRfqProductMargin = createAsyncThunk(
    "rfq/saveRfqProductMargin",
    async (formdata, { rejectWithValue }) => {
        try {
            const response = await api.post(`admin/calculate-quotation`, formdata);
            return response;
        } catch (err) {
            return rejectWithValue(err.response?.data || "Failed to change price");
        }
    }
);

export const approveRejectPaymentReceipt = createAsyncThunk(
    "rfq/approveRejectPaymentReceipt",
    async (data, { rejectWithValue }) => {
        try {
            const response = await api.post(`admin/update-payment-status/${data.id}`, data);
            return response;
        } catch (err) {
            return rejectWithValue(err.response?.data || "Failed to change");
        }
    }
);


export const sendQuotationToCustomer = createAsyncThunk(
    "rfq/sendQuotationToCustomer",
    async (data, { rejectWithValue }) => {
        try {
            const response = await api.post(`admin/send-quotation-to-client`, data);
            return response;
        } catch (err) {
            return rejectWithValue(err.response?.data || "Failed to send");
        }
    }
);

export const getSalesMemberById = createAsyncThunk(
    "rfq/getSalesMemberById",
    async (formdata, { rejectWithValue }) => {
        try {
            const response = await api.get(`admin/get-sales/members/${formdata?.parent_id}?role=${formdata?.type}`);
            const data = response.data.map(row => ({ value: row.user_id, label: `${row.name} - (RFQs : ${row.rfqs ? row.rfqs : 'N/A'})` }));
            return data;
        } catch (err) {
            return rejectWithValue(err.response?.data || "Failed to get");
        }
    }
);

export const closeDiscussion = createAsyncThunk(
    "rfq/closeDiscussion",
    async (data, { rejectWithValue }) => {
        try {
            const response = await api.post(`admin/enable-customer-chat`, data);
            return response;
        } catch (err) {
            return rejectWithValue(err.response?.data || "Failed");
        }
    }
);
export const initiatePaymentByAdmin = createAsyncThunk(
    "rfq/initiatePaymentByAdmin",
    async ({ rfq_id, formData }, { rejectWithValue }) => {
        try {
            const response = await api.post(`admin/upload-payment-receipt-by-admin/${rfq_id}`, formData,
                {
                    headers: { "Content-Type": "multipart/form-data" },
                }
            );

            return response;
        } catch (err) {
            return rejectWithValue(
                err.response?.data || "Failed to save payment"
            );
        }
    }
);

export const getRfqCommission = createAsyncThunk(
    "rfq/getRfqCommission",
    async (data, { rejectWithValue }) => {
        try {
            const response = await api.get(`admin/get-commission-details/${data.rfq_id}`);
            return response.data;
        } catch (err) {
            return rejectWithValue(err.response?.data || "Failed to get commission");
        }
    }
);

export const updateRfqCommission = createAsyncThunk(
    "rfq/updateRfqCommission",
    async (data, { rejectWithValue }) => {
        try {
            const response = await api.post(`admin/update-rfq-commission`, data);
            return response;
        } catch (err) {
            return rejectWithValue(err.response?.data || "Failed to update commission.");
        }
    }
);

export const updateAdminProceed = createAsyncThunk(
    "rfq/updateAdminProceed",
    async (data, { rejectWithValue }) => {
        try {
            const response = await api.post("admin/update-admin-proceed", {
                rfq_id: data.rfq_id,
                is_admin_proceed: data.is_admin_proceed
            });
            return response;
        } catch (err) {
            return rejectWithValue(err.response?.data || "Failed to update admin proceed status");
        }
    }
);

export const fetchAssociatedMembers = createAsyncThunk(
    "rfq/fetchAssociatedMembers",
    async (rfq_id, { rejectWithValue }) => {
        try {
            const response = await api.get(`admin/get-associated-members/${rfq_id}`);
            return response.data;
        } catch (err) {
            return rejectWithValue(err.response?.data || "Failed to load associated members");
        }
    }
);

export const reassignRfqOrOrder = createAsyncThunk(
    "rfq/reassignRfqOrOrder",
    async (data, { rejectWithValue }) => {
        try {
            const response = await api.post("admin/reassign-rfq-or-order", data);
            return response;
        } catch (err) {
            return rejectWithValue(err.response?.data || "Failed to reassign RFQ");
        }
    }
);

export const fetchAssociatedManagers = createAsyncThunk(
    "rfq/fetchAssociatedManagers",
    async (data, { rejectWithValue }) => {
        try {
            const params = new URLSearchParams({
                page: String(data.page ?? 1).trim(),
                per_page: String(data.per_page ?? 10).trim(),
            });
            const response = await api.get(`admin/get-associated-managers/${data.rfqId}?${params.toString()}`);
            return response.data;
        } catch (err) {
            return rejectWithValue(err.response?.data || "Failed to load associated managers");
        }
    }
);

export const fetchMembersByManager = createAsyncThunk(
    "rfq/fetchMembersByManager",
    async (data, { rejectWithValue }) => {
        try {
            const params = new URLSearchParams({
                page: String(data.page ?? 1).trim(),
                per_page: String(data.per_page ?? 10).trim(),
            });
            const response = await api.get(`admin/get-members-by-manager/${data.managerId}?${params.toString()}`);
            return response.data;
        } catch (err) {
            return rejectWithValue(
                err.response?.data || "Failed to load members for manager"
            );
        }
    }
);

export const fetchFinanceManagers = createAsyncThunk(
    "rfq/fetchFinanceManagers",
    async (_, { rejectWithValue }) => {
        try {
            const response = await api.get(`admin/get-finance-managers`);
            const data = response.data.map(row => ({ value: row.user_id, label: row.full_name }));
            return data;
        } catch (err) {
            return rejectWithValue(err.response?.data || "Failed to load finance managers");
        }
    }
);

export const fetchFinanceMembers = createAsyncThunk(
    "rfq/fetchFinanceMembers",
    async (user_id, { rejectWithValue }) => {
        try {
            const response = await api.get(`admin/get-finance-members?user_id=${user_id}`);
            const data = response.data.map(row => ({ value: row.user_id, label: row.full_name }));
            return data;
        } catch (err) {
            return rejectWithValue(err.response?.data || "Failed to load finance members");
        }
    }
);

export const approvePOAcknowledgement = createAsyncThunk(
    "rfq/approvePOAcknowledgement",
    async (data, { rejectWithValue }) => {
        try {
            const response = await api.post("admin/po-acknowledgement", data);
            return response;
        } catch (err) {
            return rejectWithValue(err.response?.data || "Failed to approve/reject PO acknowledgement");
        }
    }
);

export const toggleArchiveRfq = createAsyncThunk(
    "rfq/toggleArchiveRfq",
    async (data, { rejectWithValue }) => {
        try {
            const response = await api.post("admin/toggle-archive", data);
            return response;
        } catch (err) {
            return rejectWithValue(err.response?.data || "Failed to update archive status");
        }
    }
);

export const rejectRfqByProcurement = createAsyncThunk(
    "rfq/rejectRfqByProcurement",
    async ({ rfq_id, reason }, { rejectWithValue }) => {
        try {
            const response = await api.post(
                "admin/rfqs/reject-by-procurement",
                { rfq_id, reason }
            );
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);

export const reforwardToProcurement = createAsyncThunk(
    "rfq/reforwardToProcurement",
    async ({ rfq_id }, { rejectWithValue }) => {
        try {
            const response = await api.post(
                "admin/reforward-rfq-to-procurement",
                { rfq_id }
            );
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);

export const ejectRfq = createAsyncThunk(
    'rfq/ejectRfq',
    async ({ rfq_id, reason }, { rejectWithValue }) => {
        try {
            const response = await api.post('admin/eject-rfq', { rfq_id, reason });
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || { message: error.message });
        }
    }
);


const rfqSlice = createSlice({
    name: "rfq",
    initialState: {
        list_rfqs: [],
        rfq_details: null,
        selected: null,
        status: 'idle',
        loading: false,
        list_loading: false,
        customers: [],
        customersInfo: null,
        timeline: null,
        sales_managers: [],
        sales_members: [],
        rfq_products: [],
        cart_tiems: [],
        rfq_discussion_messages: [],
        rfq_summary: {},
        custom_rfq_files: [],
        vendors: [],
        rfq_product_vendors_prices: [],
        hasMore: true,
        total_count: {},
        cart_item_loading: false,
        sales_team: [],
        rfq_commission: null,
        associated_members: null,
        finance_managers: [],
        finance_members: [],
        associated_managers: {},
        manager_members: { data: [], pagination: {} },
        owner_counts: { sales: 0, procurement: 0, admin: 0 },

    },
    reducers: {
        resetStatus(state) {
            state.status = "idle";
            state.loading = false;
            state.list_loading = false
        },
        setEmptySalesTeamMember(state) {
            state.sales_team = [];
        },
        setEmptyFinanceMembers(state) {
            state.finance_members = [];
        },
        clearRfqs: (state) => {
            state.list_rfqs = [];
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchCustomer.fulfilled, (state, action) => {
                state.customers = action.payload;
            })
            .addCase(fetchSalesManager.fulfilled, (state, action) => {
                state.sales_managers = action.payload;
            })
            .addCase(fetchSalesTeamMember.fulfilled, (state, action) => {
                state.sales_members = action.payload;
            })
            .addCase(fetchRFQCustomerInfo.pending, (state, action) => {
                state.loading = true;
            })
            .addCase(fetchRFQCustomerInfo.fulfilled, (state, action) => {
                state.customersInfo = action.payload;
                state.loading = false;
            })
            .addCase(fetchRFQCustomerInfo.rejected, (state, action) => {
                state.loading = false;
            })
            .addCase(fetchTimeLine.fulfilled, (state, action) => {
                state.timeline = action.payload;
            })
            .addCase(fetchRFQProduct.pending, (state) => {
                state.list_loading = true;
            })
            .addCase(fetchRFQProduct.fulfilled, (state, action) => {
                state.rfq_products = action.payload;
                state.list_loading = false;
            })
            .addCase(fetchRFQProduct.rejected, (state) => {
                state.list_loading = false;
            })
            .addCase(updateProductQuantity.pending, (state) => {
                state.loading = true;
            })
            .addCase(updateProductQuantity.fulfilled, (state, action) => {
                state.loading = false;
            })
            .addCase(updateProductQuantity.rejected, (state) => {
                state.loading = false;
            })
            .addCase(getRfqs.pending, (state) => {
                state.list_loading = true;
            })
            .addCase(getRfqs.fulfilled, (state, action) => {
                state.list_loading = false;
                const { rfqData, rfqType } = action.payload;
                state.total_count = rfqData?.count;
                // 1. Get the newly fetched list data
                // Assuming the list itself is under a 'data' property within the rfqType key:
                const newRfqs = rfqData[rfqType]?.data || [];

                // 2. Decide whether to REPLACE or APPEND
                // We assume that if the page number is 1, it's a new search/filter, so we replace.
                // If the page number is > 1, it's a continuous load (append).
                const currentPage = rfqData[rfqType]?.pagination?.current_page || 1;

                if (currentPage === 1) {
                    // First page of a search/filter: REPLACE the old list
                    state.list_rfqs = newRfqs;
                } else {
                    // Subsequent pages (continuous scroll/pagination): APPEND the new list
                    state.list_rfqs = [...state.list_rfqs, ...newRfqs];
                }

                // 3. Update pagination status
                const pagination = rfqData[rfqType]?.pagination;

                if (pagination && pagination.current_page >= pagination.last_page) {
                    state.hasMore = false;
                } else {
                    state.hasMore = true;
                }
                state.owner_counts = rfqData?.owner_counts || { sales: 0, procurement: 0, admin: 0 };
                state.my_status_counts = action.payload.rfqData?.data?.my_status_counts || {};
                state.unread_counts = rfqData?.unread_counts ?? state.unread_counts;
                state.unread_type_counts = rfqData?.unread_type_counts ?? state.unread_type_counts;
            })
            .addCase(getRfqs.rejected, (state) => {
                state.list_loading = false;
            })
            .addCase(getRfqById.pending, (state) => {
                state.list_loading = true;
            })
            .addCase(getRfqById.fulfilled, (state, action) => {
                state.list_loading = false;
                state.rfq_details = action.payload;
            })
            .addCase(getRfqById.rejected, (state) => {
                state.list_loading = false;
            })
            .addCase(deleteRfq.pending, (state) => {
                state.loading = true;
            })
            .addCase(deleteRfq.fulfilled, (state) => {
                state.loading = false;
            })
            .addCase(deleteRfq.rejected, (state) => {
                state.loading = false;
            })
            .addCase(removeRfqItems.pending, (state) => {
                state.loading = true;
            })
            .addCase(removeRfqItems.fulfilled, (state) => {
                state.loading = false;
            })
            .addCase(removeRfqItems.rejected, (state) => {
                state.loading = false;
            })
            .addCase(generateRfqQuotation.pending, (state) => {
                state.loading = true;
            })
            .addCase(generateRfqQuotation.fulfilled, (state) => {
                state.loading = false;
            })
            .addCase(generateRfqQuotation.rejected, (state) => {
                state.loading = false;
            })
            .addCase(generateMaterialSubbmital.pending, (state) => {
                state.loading = true;
            })
            .addCase(generateMaterialSubbmital.fulfilled, (state) => {
                state.loading = false;
            })
            .addCase(generateMaterialSubbmital.rejected, (state) => {
                state.loading = false;
            })
            .addCase(deleteCustomRfqFile.pending, (state) => {
                state.loading = true;
            })
            .addCase(deleteCustomRfqFile.fulfilled, (state) => {
                state.loading = false;
            })
            .addCase(deleteCustomRfqFile.rejected, (state) => {
                state.loading = false;
            })
            .addCase(installationCharge.pending, (state) => {
                state.loading = true;
            })
            .addCase(installationCharge.fulfilled, (state) => {
                state.loading = false;
            })
            .addCase(installationCharge.rejected, (state) => {
                state.loading = false;
            })
            .addCase(VATCharge.pending, (state) => {
                state.loading = true;
            })
            .addCase(VATCharge.fulfilled, (state) => {
                state.loading = false;
            })
            .addCase(VATCharge.rejected, (state) => {
                state.loading = false;
            })
            .addCase(updateDeliveryCharge.pending, (state) => {
                state.loading = true;
            })
            .addCase(updateDeliveryCharge.fulfilled, (state) => {
                state.loading = false;
            })
            .addCase(updateDeliveryCharge.rejected, (state) => {
                state.loading = false;
            })
            .addCase(approveRfq.pending, (state) => {
                state.loading = true;
            })
            .addCase(approveRfq.fulfilled, (state) => {
                state.loading = false;
            })
            .addCase(approveRfq.rejected, (state) => {
                state.loading = false;
            })
            .addCase(salesApproveRfq.pending, (state) => {
                state.loading = true;
            })
            .addCase(salesApproveRfq.fulfilled, (state) => {
                state.loading = false;
            })
            .addCase(salesApproveRfq.rejected, (state) => {
                state.loading = false;
            })
            .addCase(procurementApproveRfq.pending, (state) => {
                state.loading = true;
            })
            .addCase(procurementApproveRfq.fulfilled, (state) => {
                state.loading = false;
            })
            .addCase(procurementApproveRfq.rejected, (state) => {
                state.loading = false;
            })
            .addCase(bulkActionRfq.pending, (state) => {
                state.loading = true;
            })
            .addCase(bulkActionRfq.fulfilled, (state) => {
                state.loading = false;
            })
            .addCase(bulkActionRfq.rejected, (state) => {
                state.loading = false;
            })
            .addCase(addRfq.pending, (state) => {
                state.loading = true;
            })
            .addCase(addRfq.fulfilled, (state) => {
                state.loading = false;
            })
            .addCase(addRfq.rejected, (state) => {
                state.loading = false;
            })
            .addCase(assignRfqToSalesManager.pending, (state) => {
                state.loading = true;
            })
            .addCase(assignRfqToSalesManager.fulfilled, (state) => {
                state.loading = false;
            })
            .addCase(assignRfqToSalesManager.rejected, (state) => {
                state.loading = false;
            })
            .addCase(assignRfqToSalesMember.pending, (state) => {
                state.loading = true;
            })
            .addCase(assignRfqToSalesMember.fulfilled, (state) => {
                state.loading = false;
            })
            .addCase(assignRfqToSalesMember.rejected, (state) => {
                state.loading = false;
            })
            .addCase(fetchCartItem.pending, (state) => {
                state.cart_item_loading = true;
            })
            .addCase(fetchCartItem.fulfilled, (state, action) => {
                state.cart_item_loading = false;
                state.cart_tiems = action.payload?.data;
            })
            .addCase(fetchCartItem.rejected, (state) => {
                state.cart_item_loading = false;
            })
            .addCase(saveRfqDiscussion.pending, (state) => {
                state.loading = true;
            })
            .addCase(saveRfqDiscussion.fulfilled, (state, action) => {
                state.loading = false;
            })
            .addCase(saveRfqDiscussion.rejected, (state) => {
                state.loading = false;
            })
            .addCase(getRfqMessages.pending, (state) => {
                state.list_loading = true;
            })
            .addCase(getRfqMessages.fulfilled, (state, action) => {
                state.list_loading = false;
                state.rfq_discussion_messages = action.payload;
            })
            .addCase(getRfqMessages.rejected, (state) => {
                state.list_loading = false;
            })
            .addCase(getRfqSummary.fulfilled, (state, action) => {
                state.rfq_summary = action.payload;
            })
            .addCase(getCustomRfqFile.pending, (state) => {
                state.loading = true;
            })
            .addCase(getCustomRfqFile.fulfilled, (state, action) => {
                state.loading = false;
                state.custom_rfq_files = action.payload;
            })
            .addCase(getCustomRfqFile.rejected, (state) => {
                state.loading = false;
            })
            .addCase(sendMaterialSubmittal.pending, (state) => {
                state.loading = true;
            })
            .addCase(sendMaterialSubmittal.fulfilled, (state, action) => {
                state.loading = false;
            })
            .addCase(sendMaterialSubmittal.rejected, (state) => {
                state.loading = false;
            })
            .addCase(rfqMoveToOrder.pending, (state) => {
                state.loading = true;
            })
            .addCase(rfqMoveToOrder.fulfilled, (state, action) => {
                state.loading = false;
            })
            .addCase(rfqMoveToOrder.rejected, (state) => {
                state.loading = false;
            })
            .addCase(sendRfqToAdmin.pending, (state) => {
                state.loading = true;
            })
            .addCase(sendRfqToAdmin.fulfilled, (state, action) => {
                state.loading = false;
            })
            .addCase(sendRfqToAdmin.rejected, (state) => {
                state.loading = false;
            })
            .addCase(sendRfqToManager.pending, (state) => {
                state.loading = true;
            })
            .addCase(sendRfqToManager.fulfilled, (state, action) => {
                state.loading = false;
            })
            .addCase(sendRfqToManager.rejected, (state) => {
                state.loading = false;
            })
            .addCase(sendRfqToProcurementManager.pending, (state) => {
                state.loading = true;
            })
            .addCase(sendRfqToProcurementManager.fulfilled, (state, action) => {
                state.loading = false;
            })
            .addCase(sendRfqToProcurementManager.rejected, (state) => {
                state.loading = false;
            })
            .addCase(getPriceVrientVendor.fulfilled, (state, action) => {
                state.loading = false;
                // state.vendors = action.payload;
                const { index, data } = action.payload;
                if (!state.vendors) state.vendors = [];

                while (state.vendors.length <= index) {
                    state.vendors.push([]);
                }

                state.vendors[index] = data || [];
            })
            .addCase(addVendorPrice.pending, (state) => {
                state.loading = true;
            })
            .addCase(addVendorPrice.fulfilled, (state, action) => {
                state.loading = false;
            })
            .addCase(addVendorPrice.rejected, (state) => {
                state.loading = false;
            })
            .addCase(getVendorPrice.pending, (state) => {
                state.loading = true;
            })
            .addCase(getVendorPrice.fulfilled, (state, action) => {
                state.loading = false;
                state.rfq_product_vendors_prices = action.payload
            })
            .addCase(getVendorPrice.rejected, (state) => {
                state.loading = false;
            })
            .addCase(saveRfqProductMargin.pending, (state) => {
                state.loading = true;
            })
            .addCase(saveRfqProductMargin.fulfilled, (state, action) => {
                state.loading = false;
            })
            .addCase(saveRfqProductMargin.rejected, (state) => {
                state.loading = false;
            })
            .addCase(approveRejectPaymentReceipt.pending, (state) => {
                state.loading = true;
            })
            .addCase(approveRejectPaymentReceipt.fulfilled, (state, action) => {
                state.loading = false;
            })
            .addCase(approveRejectPaymentReceipt.rejected, (state) => {
                state.loading = false;
            })
            .addCase(sendQuotationToCustomer.pending, (state) => {
                state.loading = true;
            })
            .addCase(sendQuotationToCustomer.fulfilled, (state, action) => {
                state.loading = false;
            })
            .addCase(sendQuotationToCustomer.rejected, (state) => {
                state.loading = false;
            })
            .addCase(getSalesMemberById.fulfilled, (state, action) => {
                state.sales_team = action.payload;
            })
            .addCase(closeDiscussion.pending, (state) => {
                state.loading = true;
            })
            .addCase(closeDiscussion.fulfilled, (state, action) => {
                state.loading = false;
            })
            .addCase(closeDiscussion.rejected, (state) => {
                state.loading = false;
            })
            .addCase(initiatePaymentByAdmin.pending, (state) => {
                state.loading = true;
            })
            .addCase(initiatePaymentByAdmin.fulfilled, (state, action) => {
                state.loading = false;
            })
            .addCase(initiatePaymentByAdmin.rejected, (state) => {
                state.loading = false;
            })
            .addCase(getRfqCommission.pending, (state) => {
                state.loading = true;
            })
            .addCase(getRfqCommission.fulfilled, (state, action) => {
                state.rfq_commission = action.payload;
                state.loading = false;
            })
            .addCase(getRfqCommission.rejected, (state) => {
                state.loading = false;
            })
            .addCase(updateRfqCommission.pending, (state) => {
                state.loading = true;
            })
            .addCase(updateRfqCommission.fulfilled, (state) => {
                state.loading = false;
            })
            .addCase(updateRfqCommission.rejected, (state) => {
                state.loading = false;
            })
            .addCase(updateAdminProceed.pending, (state) => {
                state.loading = true;
            })
            .addCase(updateAdminProceed.fulfilled, (state) => {
                state.loading = false;
            })
            .addCase(updateAdminProceed.rejected, (state) => {
                state.loading = false;
            })
            .addCase(fetchAssociatedMembers.pending, (state) => {
                state.loading = true;
            })
            .addCase(fetchAssociatedMembers.fulfilled, (state, action) => {
                state.loading = false;
                state.associated_members = action.payload || null;
            })
            .addCase(fetchAssociatedMembers.rejected, (state) => {
                state.loading = false;
            })
            .addCase(fetchAssociatedManagers.pending, (state) => {
                state.loading = true;
            })
            .addCase(fetchAssociatedManagers.fulfilled, (state, action) => { // Line 1250
                state.loading = false;
                const newManagersData = action.payload || {}; // Ensure newManagersData is an object

                if (!state.associated_managers) {
                    state.associated_managers = {};
                }
                Object.keys(newManagersData).forEach(department => {
                    const departmentData = newManagersData[department];
                    const currentPage = departmentData.pagination.current_page;

                    if (currentPage === 1) {
                        // If it's the first page, replace the data for that department
                        state.associated_managers[department] = departmentData;
                    } else if (state.associated_managers[department]) {
                        // If it's a subsequent page, append new members to the existing list
                        state.associated_managers[department].data.push(...departmentData.data);
                        // Update pagination info
                        state.associated_managers[department].pagination = departmentData.pagination;
                    } else {
                        // If the department doesn't exist in the state yet, add it
                        state.associated_managers[department] = departmentData;
                    }
                });
            })
            .addCase(fetchAssociatedManagers.rejected, (state) => {
                state.loading = false;
            })
            .addCase(fetchMembersByManager.pending, (state) => {
                state.loading = true;
            })
            .addCase(fetchMembersByManager.fulfilled, (state, action) => {
                state.loading = false;
                const { data, pagination } = action.payload;
                if (pagination.current_page === 1) {
                    state.manager_members = { data, pagination };
                } else {
                    state.manager_members.data.push(...data);
                    state.manager_members.pagination = pagination;
                }
            })
            .addCase(fetchMembersByManager.rejected, (state) => {
                state.loading = false;
            })
            .addCase(reassignRfqOrOrder.pending, (state) => {
                state.loading = true;
            })
            .addCase(reassignRfqOrOrder.fulfilled, (state) => {
                state.loading = false;
            })
            .addCase(reassignRfqOrOrder.rejected, (state) => {
                state.loading = false;
            })
            .addCase(fetchFinanceManagers.pending, (state) => {
                state.loading = true;
            })
            .addCase(fetchFinanceManagers.fulfilled, (state, action) => {
                state.finance_managers = action.payload;
                state.loading = false;
            })
            .addCase(fetchFinanceManagers.rejected, (state) => {
                state.loading = false;
            })
            .addCase(fetchFinanceMembers.pending, (state) => {
                state.loading = true;
            })
            .addCase(fetchFinanceMembers.fulfilled, (state, action) => {
                state.finance_members = action.payload;
                state.loading = false;
            })
            .addCase(fetchFinanceMembers.rejected, (state) => {
                state.loading = false;
            })
            .addCase(approvePOAcknowledgement.pending, (state) => {
                state.loading = true;
            })
            .addCase(approvePOAcknowledgement.fulfilled, (state, action) => {
                state.loading = false;
            })
            .addCase(approvePOAcknowledgement.rejected, (state) => {
                state.loading = false;
            })
            .addCase(toggleArchiveRfq.pending, (state) => {
                state.loading = true;
            })
            .addCase(toggleArchiveRfq.fulfilled, (state) => {
                state.loading = false;
            })
            .addCase(toggleArchiveRfq.rejected, (state) => {
                state.loading = false;
            })
            .addCase(ejectRfq.pending, (state) => {
                state.loading = true;
            })
            .addCase(ejectRfq.fulfilled, (state) => {
                state.loading = false;
            })
            .addCase(ejectRfq.rejected, (state) => {
                state.loading = false;
            })
            .addCase(rejectRfqByProcurement.pending, (state) => {
                state.loading = true;
            })
            .addCase(rejectRfqByProcurement.fulfilled, (state, action) => {
                state.loading = false;
            })
            .addCase(rejectRfqByProcurement.rejected, (state) => {
                state.loading = false;
            })
            .addCase(reforwardToProcurement.pending, (state) => {
                state.loading = true;
            })
            .addCase(reforwardToProcurement.fulfilled, (state) => {
                state.loading = false;
            })
            .addCase(reforwardToProcurement.rejected, (state) => {
                state.loading = false;
            });
    }
});

// export const { resetStatus, setEmptySalesTeamMember, clearRfqs } = rfqSlice.actions;
export const { resetStatus, setEmptySalesTeamMember, setEmptyFinanceMembers, clearRfqs } = rfqSlice.actions;
export default rfqSlice.reducer;
